var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.628,
    height: 13.628,
    viewBox: "0 0 13.628 13.628",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-mode-edit",
    "data-name": "Icon material-mode-edit",
    d: "M4.5,15.285v2.839H7.339l8.372-8.372L12.872,6.913ZM17.906,7.556a.754.754,0,0,0,0-1.067L16.135,4.718a.754.754,0,0,0-1.067,0L13.682,6.1l2.839,2.839Z",
    transform: "translate(-4.5 -4.496)",
    fill: "#0376a8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ed83e872c3235788a30ee09bcf639f88.svg";
export { ForwardRef as ReactComponent };